import { combineReducers } from "redux";

import { reducer as notifications } from "react-notification-system-redux";

import { constant } from "./constant.reducer";
import { customer } from "./customer.reducer";
import { orders } from "./orders.reducer";
import { user } from "./user.reducer";
import { credentials } from "./credentials.reducer";
import { requiredActions } from "./required-actions.reducer";

export default combineReducers({
  notifications,
  constant,
  customer,
  orders,
  user,
  credentials,
  requiredActions,
});
